export default __webpack_public_path__ + "static/media/i246vp.3b0a3d44.webp";